import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThemeColorSwitcherService {
    private renderer: Renderer2;
    private isDarkMode = new BehaviorSubject<boolean>(false);

    darkModeState = this.isDarkMode.asObservable();

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
        this.setInitialAppTheme();
    }

    enableDark() {
        this.renderer.setAttribute(document.body, 'data-theme', 'dark');
        this.isDarkMode.next(true);
        localStorage.setItem('darkMode', 'true');
    }

    enableLight() {
        this.renderer.removeAttribute(document.body, 'data-theme');
        this.isDarkMode.next(false);
        localStorage.setItem('darkMode', 'false');
    }

    toggleTheme(isDarkMode: boolean) {
        if (isDarkMode) {
            this.enableDark();
        } else {
            this.enableLight();
        }
    }

    setInitialAppTheme() {
        const darkMode = localStorage.getItem('darkMode') === 'true';
        this.toggleTheme(darkMode);
    }
}
